import React from 'react';
import { Box, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { dieslova } from './patternSuperGroups';

interface Props {
  backLabel: string;
  title: string;
  count: number;
  onBack: () => void;
}

const DrillHeader: React.FC<Props> = ({ backLabel, title, count, onBack }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2.25, flexWrap: 'wrap' }}>
    <Button
      variant="outlined"
      onClick={onBack}
      startIcon={<ArrowBackIcon />}
      sx={{
        height: 36,
        borderRadius: 1,
        fontSize: 13.5,
        fontWeight: 600,
        color: 'text.primary',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        textTransform: 'none',
        '&:hover': { bgcolor: 'background.paper', borderColor: 'primary.main' },
      }}
    >
      {backLabel}
    </Button>
    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5 }}>
      <Box component="h2" sx={{ m: 0, fontSize: 22, fontWeight: 800 }}>
        {title}
      </Box>
      <Box component="span" sx={{ fontSize: 14, color: 'text.secondary' }}>
        {count} {dieslova(count)}
      </Box>
    </Box>
  </Box>
);

export default DrillHeader;
